import { Component, OnInit } from '@angular/core';
import { IniciativaDetalle, TablaMisIniciativas } from 'src/app/interfaces/interfaces';
import { Paginado } from 'src/app/models/paginado';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-lider-proyecto',
  templateUrl: './lider-proyecto.component.html',
  styleUrls: ['./lider-proyecto.component.scss']
})
export class LiderProyectoComponent implements OnInit {
  animacionRecargaTabla: string;
  emailUser: string;
  tablaIniciativas: TablaMisIniciativas[] = [];
  paginaActual: Paginado;
  iniciativaSeleccionada: IniciativaDetalle;

  constructor(private authService: AuthService) {
    this.authService.user.subscribe((user: string) => {
      this.emailUser = user;
    });
    this.animacionRecargaTabla = 'animated fadeIn';
  }

  ngOnInit() {
    this.paginaActual = new Paginado();
    this.paginaActual.email = this.emailUser;
    this.paginaActual.numeroPagina = 0;
    this.cargarSiguientes();

    // Subir a tope de pagina
    this.scrollInicio();
  }

  verDetallesIniciativa(idIniciativa: number, tipo: number) { }

  cargarAnteriores() { }

  cargarSiguientes() { }

  formarImpacto(impacto: string): { nombreImpacto: string; detalleImpacto: string } {
    const listImpacto: string[] = impacto.trim().split('%');
    return { nombreImpacto: listImpacto[0], detalleImpacto: listImpacto[1] };
  }

  private animarTablaRecargar() {
    this.animacionRecargaTabla = '';
    this.animacionRecargaTabla = 'animated pulse';
  }

  recargarTablaIniciativas(act: number){
    
  }

  cambiarIniciativa(iniciativa: IniciativaDetalle) {
    this.iniciativaSeleccionada = iniciativa;
  }

  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const posicion = window.pageYOffset;
      if (posicion > 0) {
        window.scrollTo(0, posicion - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
